import React from 'react';
import CombinationCard from './CombinationCard';
import { CombinationListWrapper } from '../styled';
import { Combinations } from '../types';
import useCombinationFilters from '../hooks/useCombinationFilters';

export default function DimensionWithCombinations({
  combinations = [],
  aiConfigList,
  customCss,
  level,
}: Combinations) {
  const { activeCombinations, deletionInProgressCombinations } =
    useCombinationFilters(combinations);

  return (
    <CombinationListWrapper customCss={customCss}>
      {activeCombinations.map((combinationSet, ind) => (
        <CombinationCard
          key={ind}
          combinationSet={combinationSet}
          level={level}
          aiConfigList={aiConfigList}
        />
      ))}
      {deletionInProgressCombinations.map((combinationSet, ind) => (
        <CombinationCard
          key={ind}
          combinationSet={combinationSet}
          level={level}
          aiConfigList={aiConfigList}
        />
      ))}
    </CombinationListWrapper>
  );
}
